const API_BASE = "https://anilkarakkattuu.com/api";
const AUTH = "Basic " + btoa("u741066660_tkVdr:niuyEFXhNG");

export async function getSummary() {
  const res = await fetch(`${API_BASE}/summary.php`, {
    headers: { Authorization: AUTH },
  });

  if (!res.ok) {
    throw new Error(`Failed to fetch summary: ${res.status}`);
  }

  return res.json();
}

export async function getSubmissions() {
  const res = await fetch(`${API_BASE}/submissions.php`, {
    headers: { Authorization: AUTH },
  });

  if (!res.ok) {
    throw new Error(`Failed to fetch submissions: ${res.status}`);
  }

  return res.json();
}

